'use client';

import Link from 'next/link';
import { useEffect } from 'react';

// Route-level error boundary. Replaces the bare framework error screen with a
// branded page that offers recovery (reset) and a path back into the app.
export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface for GlitchTip/OpenReplay. Log the digest/message only — no PII.
    console.error('[encyclopedia] route error:', error?.digest ?? error?.message);
  }, [error]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-5 bg-white px-4 text-center">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#a11216]">
        Something went wrong
      </p>
      <h1 className="text-4xl font-bold text-[#022233]">Unexpected error</h1>
      <p className="max-w-md text-[#475569]">
        An unexpected error occurred. Try again, or head back to your dashboard.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={reset}
          className="rounded-lg bg-[#066FA9] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#055987]"
        >
          Try again
        </button>
        <Link
          href="/dashboard"
          className="rounded-lg border border-[#e2e8f0] px-5 py-2.5 text-sm font-semibold text-[#022233] transition hover:bg-[#f1f5f9]"
        >
          Back to Dashboard
        </Link>
      </div>
    </main>
  );
}
